import { render, staticRenderFns } from "./product.vue?vue&type=template&id=930cfd96&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('930cfd96')) {
      api.createRecord('930cfd96', component.options)
    } else {
      api.reload('930cfd96', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=930cfd96&", function () {
      api.rerender('930cfd96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/product.vue"
export default component.exports